module.exports = __webpack_public_path__ + "img/battle-crackers-find-opposition.4b2e34c8.jpg";